import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Rect } from "react-native-svg";

export const IconAspectRatio11: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAspectRatio11"><Rect x="3" y="3" width="18" height="18" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio11;
